import { NotificationManager } from 'react-notifications'
import { NotificationSuccessTimeOut } from '../../../../constants/Config'
import { LOAD_ACTION_PROGRAM_ASSIGNED, LOADED_ACTION_PROGRAM_ASSIGNED, FAILED_ACTION_PROGRAM_ASSIGNED, CANCEL_ACTION_PROGRAM_ASSIGNED } from '../../../../constants/ActionTypes'
import {postRequest,getRequest,putRequest} from '../../../actions/Axios'
import {GET_CONTAB_ACTIVE_REFERENCES,GET_CONTAB_ACTIVE_ACTION,GET_DOCUMENT_INTERFACE,GET_ALL_ACTION_PROGRAM_ACCOUNT_DATA,TOOGLE_DRAWER_CONTAB_ACTION_PROGRAM_ACCOUNT,
    SET_ADD_ACTION_PROGRAM_ACCOUNT_MODAL_OPEN,SET_ADD_ACTION_PROGRAM_ACCOUNT_MODAL_CLOSE,SET_SEARCH_APC,FILTER_ACTION_PROGRAM_ACCOUNT,SELECT_FILTER_OPTION_ACTION_PROGRAM_ACCOUNT,
    ADD_Actions_Assigned,ADD_ACTION_ACCOUNT,RESET_ACTION_ACCOUNT,OPEN_CLOSE_ACTION_PROGRAM_ACCOUNT
    } from '../../../../constants/ActionTypes'

    export const getContabReferences=()=>(dispatch)=>{
        dispatch(getRequest(`/ContabReference`,{}))
        .then(resp=>{
            const {payload:{data}}=resp;
            dispatch({
                type:GET_CONTAB_ACTIVE_REFERENCES,
                payload:data
            })
        })
        .catch(err=>console.log(err))
    }

    export const getContabAction=()=>(dispatch)=>{
        dispatch(getRequest(`/ContabAction`,{}))
        .then(resp=>{
            const {payload:{data}}=resp;
            dispatch({
                type:GET_CONTAB_ACTIVE_ACTION,
                payload:data
            })
        })
        .catch(err=>console.log(err))
    }


    export const getDocumentInterface=()=>(dispatch)=>{
        dispatch(getRequest(`/ActionProgramAccount/GetDocumentInterface`,{}))
        .then(resp=>{
            const {payload:{data}}=resp;
            dispatch({
                type:GET_DOCUMENT_INTERFACE,
                payload:data
            })
        })
        .catch(err=>console.log(err))
    }



    export  const addActionProgramAccount=(params,body,CallBack)=>(dispatch)=>{
        dispatch(postRequest("/ActionProgramAccount",params,body))
        .then(resp=>{
            const {payload:{data,status}}=resp;
            CallBack(data,status)
        }).catch(error=>console.log(error));
    }   

    export  const updateActionProgramAccount=({Id},body,CallBack)=>(dispatch)=>{
    dispatch(putRequest(`/ActionProgramAccount/${Id}`,{},{ ...body,Id}))
    .then(resp=>{
        const {payload:{data,status}}=resp;
        CallBack(data,status)
    }).catch(error=>console.log(error));
    }



    export const GetAllActionProgramAccount=()=>(dispatch)=>{

        dispatch(getRequest("/ActionProgramAccount/GetAll",{}))
        .then(resp=>{
            const {payload:{data}}=resp;
    
            dispatch({
                type:GET_ALL_ACTION_PROGRAM_ACCOUNT_DATA,
                payload:data
            })
        }).catch(error=>console.log(error));
    }

    export const GetAllActionProgramAccountNewApproach=()=>(dispatch)=>{
        dispatch(getRequest("/ActionProgramAccount/GetDataAllNewApproach",{}))
        .then(resp=>{
            const {payload:{data}}=resp;
    
            dispatch({
                type:GET_ALL_ACTION_PROGRAM_ACCOUNT_DATA,
                payload:data
            })
        }).catch(error=>console.log(error));
    }

export const actionProgramErrorMessage = error => {
  const response = error?.error?.response ?? error?.response
  const data = response?.data
  return (typeof data === 'string' ? data : data?.detail ?? data?.title)
    || error?.message || 'No se pudo cargar o guardar la configuración contable. Vuelva a intentarlo.'
}

const assignedParams = (moduleInterfaceId, DocumentEmissionId, currencyId) => {
  const params = { moduleInterfaceId: Number(moduleInterfaceId), DocumentEmissionId: Number(DocumentEmissionId), currencyId: Number(currencyId) }
  if (!Object.values(params).every(value => Number.isInteger(value) && value > 0))
    throw new Error('Debe seleccionar una interfaz, un documento y una moneda válidos.')
  return params
}

export const GetActionProgramAssignedVisualization = (moduleInterfaceId, DocumentEmissionId, currencyId) => async dispatch => {
  const params = assignedParams(moduleInterfaceId, DocumentEmissionId, currencyId)
  const { payload: { data, status } } = await dispatch(getRequest('/ActionProgramCatalogAccount/GetActionProgramAssignedVisualization', params))
  if (!Array.isArray(data)) throw new Error('La respuesta de configuración contable no es válida.')
  return { data, status }
}

export const GetActionProgramAssigned = (moduleInterfaceId, DocumentEmissionId, currencyId, isCurrent = () => true) => async dispatch => {
  const params = assignedParams(moduleInterfaceId, DocumentEmissionId, currencyId)
  const { payload: { data, status } } = await dispatch(getRequest('/ActionProgramCatalogAccount/GetActionProgramAssigned', params))
  if (!Array.isArray(data)) throw new Error('La respuesta de configuración contable no es válida.')
  if (isCurrent())
    dispatch({ type: ADD_Actions_Assigned, payload: data })
  return { data, status }
}

// Resolve the document inside the request lifecycle so an older lookup cannot open a new modal.
export const LoadActionProgramAssigned = ({ moduleInterfaceId, DocumentEmissionId, currencyId, documentAbbreviation, modify = false }, owner) => async (dispatch, getState) => {
  if (getState().auth?.company?.isSimpleBilling === true) {
    dispatch(CancelActionProgramAssigned())
    return null
  }
  const requestId = (getState().ActionProgramAccount.assignedRequestId || 0) + 1
  const companyId = getState().auth?.company?.id
  dispatch({ type: LOAD_ACTION_PROGRAM_ASSIGNED, requestId, owner })
  const isCurrent = () => getState().ActionProgramAccount.assignedRequestId === requestId
    && getState().ActionProgramAccount.assignedOwner === owner && getState().auth?.company?.id === companyId
    && getState().auth?.company?.isSimpleBilling !== true
  try {
    if (documentAbbreviation != null && !DocumentEmissionId) {
      if (!Number.isInteger(Number(moduleInterfaceId)) || Number(moduleInterfaceId) <= 0
          || !Number.isInteger(Number(currencyId)) || Number(currencyId) <= 0)
        throw new Error('Debe seleccionar una interfaz y una moneda válidas.')
      const { payload: { data: document } } = await dispatch(getRequest('DocumentEmission/GetDocumentByCode', { DocumentAbbreviation: documentAbbreviation }))
      if (!isCurrent()) return null
      DocumentEmissionId = document?.id
    }
    const params = assignedParams(moduleInterfaceId, DocumentEmissionId, currencyId)
    const result = await dispatch(GetActionProgramAssigned(params.moduleInterfaceId, params.DocumentEmissionId, params.currencyId, isCurrent))
    if (!isCurrent()) return null
    const openOrClose = result.data.length > 0 && (modify || result.data.some(row => !row.actionProgramCatalogAccountId || !row.catalogAccountId))
    dispatch({ type: LOADED_ACTION_PROGRAM_ASSIGNED, requestId, payload: { ...params, ...result, openOrClose } })
    if (result.data.length === 0)
      NotificationManager.warning('No hay acciones programadas para esta selección.', 'Aviso', NotificationSuccessTimeOut)
    return result
  } catch (error) {
    if (!isCurrent()) return null
    const message = actionProgramErrorMessage(error)
    dispatch({ type: FAILED_ACTION_PROGRAM_ASSIGNED, requestId, payload: message })
    NotificationManager.error(message, 'Configuración contable', NotificationSuccessTimeOut)
    return null
  }
}

export const CancelActionProgramAssigned = owner => (dispatch, getState) => {
  if (owner === undefined || getState().ActionProgramAccount.assignedOwner === owner)
    dispatch({ type: CANCEL_ACTION_PROGRAM_ASSIGNED })
}

export const AddActionProgramCatalogAccount = pmActionCatalog => async dispatch => {
  const { payload: { data, status } } = await dispatch(postRequest('/ActionProgramCatalogAccount/AddActionProgramCatalogAccount', {}, pmActionCatalog))
  return { data, status }
}

export const UpdateActionProgramCatalogAccount = pmActionCatalog => async dispatch => {
  const { payload: { data, status } } = await dispatch(putRequest('/ActionProgramCatalogAccount/UpdateActionProgramCatalogAccount', {}, pmActionCatalog))
  return { data, status }
}

    export const ActionProgramAccount=(ActionAccount)=>{
        return{
            type:ADD_ACTION_ACCOUNT,
            payload:ActionAccount
        }
    }
    

    export const ResetActionsAssigned=()=>({
        type:RESET_ACTION_ACCOUNT
    })


    
export const ActionProgramAccountModalOpenAndClose = data => ({ type: OPEN_CLOSE_ACTION_PROGRAM_ACCOUNT, payload: data })

    export const  addActionProgramAccountModalOpen =()=>({
        type:SET_ADD_ACTION_PROGRAM_ACCOUNT_MODAL_OPEN,
        payload:true
    })

    export const  addActionProgramAccountModalClose =()=>({
            type:SET_ADD_ACTION_PROGRAM_ACCOUNT_MODAL_CLOSE,
            payload:false
    })

    export const setSearchAPC=(seachText)=>{
        return{
            type:SET_SEARCH_APC,
            payload:seachText
        }
    }

    export const filterAPCData=()=>{
        return {
            type:FILTER_ACTION_PROGRAM_ACCOUNT
        }
    }

    export const selectOptionAPC=(optionId)=>{  

        return{
            type:SELECT_FILTER_OPTION_ACTION_PROGRAM_ACCOUNT,
            payload:optionId
        }
    }
    export const toogleDrawerAPC= ()=>(
        {
            type:TOOGLE_DRAWER_CONTAB_ACTION_PROGRAM_ACCOUNT,
        }
    )


